/**
 * Minimal public YouTube embed proxy for native iOS gallery iframes.
 * Served from a real HTTPS origin so YouTube receives a valid Referer header.
 */

import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

const YT_VIDEO_ID_RE = /^[A-Za-z0-9_-]{6,20}$/;
const EMBED_ORIGIN = (import.meta.env.VITE_URL || 'https://artist.starclinch.com').replace(/\/$/, '');

export function YouTubeEmbedProxyPage() {
  const { videoId = '' } = useParams<{ videoId: string }>();
  const isValidId = YT_VIDEO_ID_RE.test(videoId);

  useEffect(() => {
    let meta = document.querySelector('meta[name="referrer"]');
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute('name', 'referrer');
      document.head.appendChild(meta);
    }
    meta.setAttribute('content', 'strict-origin-when-cross-origin');
  }, []);

  if (!isValidId) {
    return (
      <div className="flex h-[100dvh] w-full items-center justify-center bg-black text-[13px] text-[#8E8E93]">
        Video unavailable
      </div>
    );
  }

  const embedSrc =
    `https://www.youtube.com/embed/${videoId}` +
    `?playsinline=1&origin=${encodeURIComponent(EMBED_ORIGIN)}&rel=0`;

  return (
    <div className="h-[100dvh] w-full bg-black">
      <iframe
        src={embedSrc}
        title="YouTube video"
        className="h-full w-full border-0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  );
}
